import { Component, ViewChild } from '@angular/core';
import {IonicPage, ModalController, NavController, NavParams, LoadingController, AlertController} from 'ionic-angular';
import {AutoCompleteComponent} from 'ionic2-auto-complete';
import {MovimientotesoreriaServiceProvider} from "../../providers/movimientotesoreria-service/movimientotesoreria-service";
import { EntidadServiceProvider} from '../../providers/entidad-service/entidad-service';
import { AuthServiceProvider } from '../../providers/auth-service/auth-service';
import {BusquedaPage} from "../busqueda/busqueda";

import { FileUploader } from 'ng2-file-upload';

//import {FileChooser} from '@ionic-native/file-chooser';
//import {FilePath} from '@ionic-native/file-path';
//declare var cordova: any;

/**
 * Generated class for the MovimientoTesoreriaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-movimiento-tesoreria',
  templateUrl: 'movimiento-tesoreria.html',
})
export class MovimientoTesoreriaPage {

  @ViewChild('proveedor') proveedor: AutoCompleteComponent
  titulo:any;
  nodo:any;
  detalleBusqueda: any;
  loading: any;
  tzoffset = (new Date()).getTimezoneOffset() * 60000;
  existeDocumento:boolean;
  numberMask:any;

  public uploader:FileUploader;

	objtesoreria:{id:Number, referencia:string, fecha:string, fechae:string, idestado:Number,
    idempresa:Number, idestadodocumento:Number, idtdoctes:Number, identidad:Number, entidad:string,
    valor:Number, observacion:string, idcuenta:Number};

  constructor(public servicio: MovimientotesoreriaServiceProvider,public loadingCtrl:LoadingController,
              public navCtrl: NavController, public navParams: NavParams, public alertCtrl: AlertController,
              public modalCtrl:ModalController, public entidadService: EntidadServiceProvider, public authService : AuthServiceProvider) {

    this.entidadService.idtentidad = 3; //PROVEEDOR

    this.nodo=this.navParams.data.node;

    this.uploader = new FileUploader({url: this.servicio.serverServicios + "/postesoreria/cargar/"});

    this.uploader.onAfterAddingFile = (file)=> { file.withCredentials = false; };
    this.uploader.onBeforeUploadItem = (fileitem) => {
        fileitem.remove();
    };

  	this.botonNuevo();

  	this.titulo =this.nodo.title ;

    this.numberMask = "[/\d/, /\d/, ',', /\d/, /\d/]";
  }


  ionViewDidLoad() {
    //console.log('ionViewDidLoad MovimientoTesoreriaPage');
  }

  botonNuevo()
  {
    

    this.objtesoreria={id:0, referencia:'',fecha:(new Date(Date.now() - this.tzoffset)).toISOString(), fechae:(new Date(Date.now() - this.tzoffset)).toISOString(),
      valor:0, observacion:'', identidad:3, entidad:'', idempresa:1,idestado:0,
      idestadodocumento:1,idtdoctes: this.nodo.idtmovimiento, idcuenta: this.nodo.idcuenta };

    if(this.nodo.idoperacion == 1){
      this.objtesoreria.identidad = this.authService.usuario['identidad'];
      this.objtesoreria.entidad = this.authService.usuario['entidad'];
    }
    this.existeDocumento = false;
  }

  botonGrabar(){
    if(this.objtesoreria.valor == 0){
        let alert = this.alertCtrl.create({
          title: 'Validacion de datos',
          subTitle: 'Ingrese los datos respectivos para almacenar el respectivo movimiento.',
          buttons: ['OK']
        });
        alert.present();
    }
    else{

      this.servicio.guardarMovimiento(this.objtesoreria).then(p=> {
        

        if(this.uploader.queue.length > 0){
          console.log(this.uploader);

          this.uploader.queue[0].file.name = ("documento_" + p["id"] + ".pdf");
          this.uploader.uploadAll();
        }

        this.botonNuevo();
        this.showLoader('Se guardo correctamente!!',1000);
      });
    }
  }
  botonBuscar(){
    //this.servicio.getMovimientos(this.nodo.idcuenta).subscribe(result=>{
    //  this.detalleBusqueda={'parametro':result, 'campobus':'observacion,descripciontdoctes,descripcionentidad,valor'};
    //  let myModal = this.modalCtrl.create(BusquedaPage,this.detalleBusqueda);
    //  myModal.onDidDismiss(data => {
    //    if (data != null)
    //      this.objtesoreria=data;
    //  });
    //  myModal.present();
    //})

    this.servicio.buscar(this.nodo.idtmovimiento, this.nodo.idcuenta, 0).subscribe(result=>{

      this.detalleBusqueda={'parametro':result, 'campobus':'fecha,entidad,referencia,valor,observacion'};
      let myModal = this.modalCtrl.create(BusquedaPage,this.detalleBusqueda);
      myModal.onDidDismiss(data => {
        if (data != null){
          this.objtesoreria=data;
          this.existeDocumento = this.servicio.documentExists(this.objtesoreria.id);
        }
      });
      myModal.present();
    })
  }

  abrirDocumento(){
    window.open(this.servicio.serverServicios + "/documento_"+ this.objtesoreria.id +".pdf", "_blank");
  }

  botonEliminar(){
    if(this.objtesoreria.id == 0){
        let alert = this.alertCtrl.create({
          title: 'Validacion de datos',
          subTitle: 'Seleccione un movimiento para eliminar.',
          buttons: ['OK']
        });
        alert.present();
    }
    else{
        this.objtesoreria.idestado = 1;
      
        this.servicio.guardarMovimiento(this.objtesoreria).then((result) => {
        this.showLoader('Se eliminó correctamente!!',1000);
        this.botonNuevo();
    }, (err) => {
          console.log(err);
      });

    }
  }

  showLoader(mensaje,tiempo){
 
  this.loading = this.loadingCtrl.create({
      content: mensaje,
      duration: tiempo,
      spinner: 'hide'
  });

  this.loading.present();

  this.loading.onDidDismiss(() => {
    
  });
  }

  seleccionarProveedor(evento)
  {
    
    let descripcion = evento.descripcion;
    //if(this.entidad.idtusuario != 1){
      this.proveedor.setValue(descripcion);
      this.objtesoreria.entidad = descripcion;
      this.objtesoreria.identidad = evento.id;
    //}
  }

  onKeyUp(event: any) {
    const NUMBER_REGEXP = /^\s*(\-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;

    let newValue = event.target.value;
    let regExp = new RegExp(NUMBER_REGEXP);

    if (!regExp.test(newValue)) {
      event.target.value = newValue.slice(0, -1);
    }
  }

  isValidNumber(event)
  {
    //console.log(this.objtesoreria.valor.toString().length -2 + " , " + this.objtesoreria.valor.toString().indexOf('.') )
    
      //return /\d|Backspace/.test(event.key);
      if (([8, 13, 27, 37, 38, 39, 40].indexOf(event.keyCode) > -1)) {
          // backspace, enter, escape, arrows
          return true;
      } else if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode == 190 && this.objtesoreria.valor.toString().indexOf('.') == -1 )) {
          // numbers 0 to 9 or .
          if(this.objtesoreria.valor.toString().indexOf('.') > -1 && this.objtesoreria.valor.toString().length - this.objtesoreria.valor.toString().indexOf('.') - 2  > 0)
            return false;

          return true;
      } else if (event.keyCode >= 96 && event.keyCode <= 105) {
          // numpad number
          return true;
      }
      return false;
  }
}



// WEBPACK FOOTER //
// ./src/pages/movimiento-tesoreria/movimiento-tesoreria.ts